"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chats_notifications_connect_1 = require("@cian/chats-notifications-connect");
var React = require("react");
var react_dom_1 = require("react-dom");
var chats_notificator_1 = require("../../shared/chats_notificator");
var chats_network_helper_1 = require("../utils/chats_network_helper");
exports.initializeChatsNotificator = function (element, isAuthenticated) {
    var _a = chats_network_helper_1.getChatsBaseAPI(), chatsBaseWSUri = _a.chatsBaseWSUri, chatsHttpConfig = _a.chatsHttpConfig;
    if (element && chatsHttpConfig && chatsBaseWSUri) {
        if (isAuthenticated) {
            var context = chats_notifications_connect_1.createContext(chatsHttpConfig, chatsBaseWSUri);
            var ChatsNotificatorComponentWrapped = chats_notifications_connect_1.withNotificationsCount(context)(chats_notificator_1.ChatsNotificator);
            react_dom_1.render(React.createElement(ChatsNotificatorComponentWrapped, null), element);
        }
        else {
            react_dom_1.render(React.createElement(chats_notificator_1.ChatsNotificator, { notificationsCount: null }), element);
        }
    }
    else {
        console.error('[Chats Notificator] Either element/chatsHttpConfig or chatsBaseWSUri is not specified.');
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/chats_notificator.tsx
// module id = 267
// module chunks = 2